import { HttpService } from "@/core";
import {
  ProcessConfigListResp,
  ProcessConfigPageReq,
  ProcessConfigResp,
  ProcessConfigReq,
  ModuleTypeResp,
  FormFieldConfigRelationalResp,
} from "./process-config.interface";

export class ProcessConfigService {
  static usePageApi() {
    const api = (params: ProcessConfigPageReq) =>
      HttpService.axios({
        method: "GET",
        url: "/examine_template/page",
        params,
      });
    return HttpService.usePagination<ProcessConfigListResp>(api);
  }

  static useStatusApi() {
    const api = (id: string, isEnable: boolean) =>
      HttpService.axios({
        method: "PUT",
        url: `/examine_template/${id}/enable`,
        data: { isEnable },
      });
    return HttpService.useRequest<{ id: string }>(api);
  }

  static useDetailApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/examine_template/${id}/nodes`,
      });
    return HttpService.useRequest<ProcessConfigResp>(api);
  }

  static useCreateApi() {
    const api = (id: string, data: ProcessConfigReq) =>
      HttpService.axios({
        method: "post",
        url: `/examine_template/${id}/node`,
        data,
      });
    return HttpService.useRequest<void>(api, { isOutError: true });
  }
  static useCreateListApi() {
    const api = (ids: [], data: ProcessConfigReq) =>
      HttpService.axios({
        method: "post",
        url: `/examine_template/batch/node?ids=${ids}`,
        data,
      });
    return HttpService.useRequest<void>(api, { isOutError: true });
  }
  static useModuleTypeApi() {
    const api = () =>
      HttpService.axios({
        method: "GET",
        url: `/examine_template/module_type`,
      });
    return HttpService.usePagination<ModuleTypeResp>(api);
  }

  static useFormFieldConfigRelationalApi() {
    const api = (examineCode: string) =>
      HttpService.axios({
        method: "GET",
        url: `/examine_template/${examineCode}/formFieldConfigRelational`,
      });
    return HttpService.useRequest<FormFieldConfigRelationalResp>(api);
  }
}
